// extracted by css-extract-rspack-plugin
export default {"wrapper":"fSCuL","balance":"FxKic","coin":"B0GA9","bottom":"QglXW"};